import { Button, Popover, PopoverButton, StyledPopoverPanel, PopoverItem, Indicator } from '@crazyegginc/hatch';
import { atom, useAtom } from 'jotai';
import { useQuery } from '@tanstack/react-query';
import { goalListQuery } from '../../goals/queries';
import { useSelectedSite } from '/src/hooks';

export const selectedGoalAtom = atom(null);

export function GoalSelector() {
  const [goal, setGoal] = useAtom(selectedGoalAtom);
  const { selectedSite } = useSelectedSite();

  const { data: goalsData, isFetching: fetchingGoals } = useQuery({
    ...goalListQuery({ siteId: selectedSite?.id, limit: -1 }),
    enabled: Boolean(selectedSite?.id),
  });

  const goals = goalsData?.goalList?.list ?? [];

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <PopoverButton
            as={Button}
            variant="secondary"
            size="lg"
            className={open ? '!border-dodger-blue-500' : ''}
            disabled={fetchingGoals}
          >
            {goal ? goal.name : 'Select goal'}
            <Indicator type="dropdown" className="ml-2.5" />
          </PopoverButton>

          <StyledPopoverPanel align="center" className="!max-h-[250px] !overflow-y-scroll">
            {({ close }) => (
              <>
                {goals.map((g) => (
                  <PopoverItem
                    key={`popover_goal_${g.id}`}
                    autoWidth
                    onClick={() => {
                      setGoal(g);
                      close();
                    }}
                  >
                    {g.name}
                  </PopoverItem>
                ))}
              </>
            )}
          </StyledPopoverPanel>
        </>
      )}
    </Popover>
  );
}
